import { CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import { action, computed, makeObservable, observable } from 'mobx';
import { groupBy } from 'es-toolkit';
import { Country, CountryScope } from '../models';

export class CountryStore {
  @observable countriesByScope: Map<CountryScope, Country[]> = new Map();

  @observable globalCountriesByRegion: Map<string, Country[]> = new Map();

  constructor() {
    makeObservable(this);
  }

  @action
  setCountries(scope: CountryScope, countries: Country[]): void {
    this.countriesByScope.set(scope, countries);

    if (scope === 'global') {
      const grouped = groupBy(
        countries.filter((country) => country.region),
        (country) => country.region!.displayName,
      );

      this.globalCountriesByRegion.clear();
      Object.entries(grouped).forEach(([regionName, regionCountries]) => {
        this.globalCountriesByRegion.set(regionName, regionCountries);
      });
    }
  }

  @computed
  get awardCountries(): Country[] {
    return this.countriesByScope.get('awards') ?? [];
  }

  @computed
  get countries(): Country[] {
    return this.countriesByScope.get('global') ?? [];
  }

  @computed
  get awardCountry() {
    return (id: number): Country | undefined => {
      return this.awardCountries.find((country) => country.countryId === id);
    };
  }

  getDialCode = (countryCode: string): string => {
    try {
      const callingCode = getCountryCallingCode(countryCode as CountryCode);
      return `+${callingCode}`;
    } catch {
      return '+1';
    }
  };
}
